module.exports = __webpack_public_path__ + "img/punk-fm.e27419ee.png";